import { GridStack } from 'gridstack';

/* globals Knitiv */

export default class GridStackController {
	/** @type {Knitiv.Scope} */
	$scope;

	/** @type {import('angular').IRootElementService} */
	$element;

	/** @type {Partial<import('gridstack').GridStackOptions>} */
	options = {};

	/** @type {?GridStack} */
	ref;

	/* @ngInject */
	/**
	 * @param {Knitiv.Scope} $scope
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').IRootElementService} $element
	 */
	constructor($scope, $timeout, $element) {
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.$element = $element;
		this.ref = null;

		/**
		 * @param {{ $reference: GridStack }} reference
		 * @returns {void | Promise<void>}
		 */
		// eslint-disable-next-line no-unused-vars
		this.onReady = ({ $reference }) => {};
	}

	async $onInit() {
		const $grid = this.$element.find('.grid-stack');

		this.ref = GridStack.init({
			acceptWidgets: false,
			cellHeight:    16,
			column:        12,
			float:         false,
			margin:        10,
			minRow:        5,
			resizable:     {
				handles: 'all',
			},
			...this.options,
		}, $grid.get(0));

		if (this.onReady && typeof this.onReady === 'function') {
			await this.onReady({ $reference: this.ref });
		}
	}
}
